import moment from "moment";
import modelBaseV2 from "../../model-base-v2.model";

const WeeklyEmailSummaryModel = {
  getCustomerList: () => {
    return modelBaseV2.get('/api/intf-edi/customers')
  },
  getIntfFileTypeList: () => {
    return modelBaseV2.get('/api/intf-edi/GetIntfFileType')
  },
  searchWeeklyEmailSummary: (body) => {
    return modelBaseV2.post('/api/intf-edi/weekly/summary', { body });
  },
  postWeeklyEmailSummaryDetail: (body) => {
    return modelBaseV2.post('/api/intf-edi/weekly/details', { body });
  },
  downloadSummary: (body) => {
    body.pageSize = -1;
    const paramsMapping = {
      orderBy: "2",
      pageIndex: "3",
      pageSize: "4",
      fromDate: "8",
      toDate: "9",
      sortBy: "24",
      category: "48",
      fileType: "86",
      customer: "90",
    }
    const params = Object.entries(paramsMapping).map(([key, value]) => {
      let arg = body[key];
      return {
        code: value,
        value: arg
          ? Array.isArray(arg)
            ? arg.join('^')
            : arg.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames: [
        "Weekly Email Summary"
      ],
      storedProcedureCode: "48",
      params
    }
    return modelBaseV2.postDownload('/api/executesp/export/commonexcel', { body: exportConfig }, `Weekly_Email_Summary_${moment().format('YYYYMMDDhhmm')}.xlsx`);
  },
  downloadRawData: (body) => {
    const paramsMapping = {
      fromDate: "8",
      toDate: "9",
      category: "48",
      fileType: "86",
      customer: "90",
    }
    const params = Object.entries(paramsMapping).map(([key, value]) => {
      let arg = body[key];
      return {
        code: value,
        value: arg
          ? Array.isArray(arg)
            ? arg.join('^')
            : arg.toString()
          : ""
      }
    })

    const exportConfig = {
      excelSheetNames: [
        "Weekly Email Raw Data"
      ],
      storedProcedureCode: "49",
      params
    }
    return modelBaseV2.postDownload('/api/executesp/export/commonexcel', { body: exportConfig }, `Weekly_Email_Raw_Data_${moment().format('YYYYMMDDhhmm')}.xlsx`);
  }
}

export default WeeklyEmailSummaryModel;  